import { complement, isEmpty } from 'ramda'
import { ReasonCode, CancelCause } from '~/__generated__/__types__'
export function discountRatio(price?: number | null, discountPrice?: number | null) {
  if (!price || !discountPrice) {
    return 0
  }
  return Math.abs(100 - Math.floor((discountPrice / price) * 100))
}

export function safelyParseJSON(json) {
  try {
    return JSON.parse(json)
  } catch (_err) {
    return
  }
}

export function getIsEmailRegex(value: string): boolean {
  return new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ).test(value)
}

export const trainClassifyCodeNameMap = {
  '00': 'KTX',
  '01': '새마을호',
  '02': '무궁화호',
  '04': '누리로',
  '05': '전체',
  '07': 'KTX-산천',
  '08': 'ITX-새마을',
  '09': 'ITX-청춘',
  '10': 'KTX-호남',
  '15': 'ITX-경부',
  '16': 'KTX-이음',
  '19': 'KTX-청룡',
}

export function trainClassifyCodeToName(code: string) {
  return trainClassifyCodeNameMap[code] || trainClassifyCodeNameMap['00']
}

// https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/88809720/paymentMethodCode+payType
export const paymentNameMap: { [key: string]: string } = {
  CARD: '카드',
  MOBILE: '휴대폰',
  KAKAOPAY: '카카오페이',
  PAYCO: '페이코',
  BANK: '계좌이체',
  POINT: '야놀자 포인트',
  NOL_POINT: 'NOL 포인트',
  CJ_ONE_POINT: 'CJ ONE 포인트',
  COUPON: '쿠폰',
  NCARD: '네이버페이 카드',
  NBANK: '네이버페이 계좌이체',
  NPOINT: '네이버페이 포인트',
  DIRECTCARD: '카드결제',
  OTA: '외부채널 결제',
  SMILEPAY: '스마일페이',
  SSGPAY: 'SSG페이',
  TOSS: '토스',
  CHAI: '차이',
  KT: '제휴사 (KT 멤버십)',
  SKT: '제휴사 (T 멤버십)',
  ZEROPAY: '제로페이',
  ACCOUNT: '계좌이체',
  NAVERPAY: '네이버페이',
  PAYNOW: '페이나우',
  YANOLJAPAY: '간편 계좌 결제',
  LPAY: '엘페이',
  NOLCARDPAY: 'NOL 카드 페이',
  NOL_MONEY: 'NOL 머니',
}

export const discountNameMap: { [key: string]: string } = {
  COUPON: '쿠폰',
  KT: '제휴사 (KT 멤버십)',
  SKT: '제휴사 (T 멤버십)',
}

// for type predicate
export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export function isTruthy<TValue>(
  value: TValue | null | undefined | boolean | number
): value is TValue {
  return !!value
}

// GraphQL 의 타입 필터를 위한 함수
interface GraphQLType {
  __typename?: string
}
// T: 필터링하고 싶은 객체의 타입
// U(optional): 입력 받는 객체 제한. 별도로 작성하지 않으면 any 가 된다.
// typename: 필터링 하고 싶은 타입의 이름. 일반적으로 T 와 같은 이름
// 예를 들면 A, B, C 의 유니온타입 배열에서 특정 타입만 필터링 하고 싶다면 아래와 같이 사용한다.
// type UnionType = A | B | C
// const array: UnionType[] = [...]
// array.filter(isTypeOf<A, UnionType>('A'))
// 위의 경우 입력 제한은 A, B, C 타입으로 제한되고, 필터링된 결과는 A로 추론된다
// https://bit.ly/3rhMZTC
export const isTypeOf = <T extends GraphQLType, U extends GraphQLType = any>(typename: string) => {
  return (value: T | U): value is T => value?.__typename === typename
}

// value 가 유니온 타입일때 특정 타입으로 filter 결과를 제한하고 싶을때 사용
export const getFilter = <T>(predicate: (value: unknown) => boolean) => {
  return (value: unknown): value is T => predicate(value)
}

export const cancelReason: { [key in ReasonCode]: string } = {
  [ReasonCode.Reason_001]: '단순 변심',
  [ReasonCode.Reason_002]: '예약정보 변경 (상품,일정,결제수단 등)',
  [ReasonCode.Reason_003]: '중복예약 / 이용조건 불만',
  [ReasonCode.Reason_004]: '타사 최저가 상품 이용',
  [ReasonCode.Reason_005]: '업소 요청에 따른 이용불가',
  [ReasonCode.Etc]: '직접입력',
}

export const getOrigin = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }
  return window.origin
}

export const adminCancelReason: { [key in CancelCause]?: string } = {
  [CancelCause.BusBoothCancel]: '창구취소',
}

export const isNotEmpty = complement(isEmpty)
